/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';
import Disqus from 'disqus-react';
import initFBComments from 'services/fb-comments';
import Layout from 'layout';
import ArticlePreview from 'components/blog/blogArticlePreview';
import Img from 'gatsby-image';
import imgFB from 'img/blog/social-share-facebook.svg';
import imgLI from 'img/blog/social-share-linkedin.svg';
import imgTwitter from 'img/blog/social-share-twitter.svg';
import { format } from 'date-fns';
import * as Styled from './styled';
import NewsletterBox from '../newsletterBox';

export default (Content) => (props) => {
  const {
    related,
    title,
    description,
    img,
    author,
    // imgSocial,
    date,
    url,
    tutorials,
    // category,
    // descriptionSocial
    timeToRead,
    metaTitle,
  } = props;
  useEffect(() => {
    initFBComments();
  }, []);

  const renderRelatedList = () => {
    if (!related || related.length === 0) return false;

    const list = related.map((el) => (
      <li key={el.link} className="col-12 col-md-6 col-lg-4">
        <ArticlePreview {...el} />
      </li>
    ));
    return (
      <section>
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-auto">
              <h3>You might also enjoy</h3>
            </div>
          </div>
          <ul className="feature-list feature-list-sm row justify-content-center">{list}</ul>
        </div>
      </section>
    );
  };

  const renderFacebookComments = () => (
    <section style={{ paddingTop: '1rem' }}>
      <div className="container">
        <div className="row justify-content-center mb-5 mt-4">
          <div style={{ width: '100%', maxWidth: '800px' }} className="col-auto text-center">
            <div
              style={{ width: '100%' }}
              data-mobile="false"
              className="fb-comments"
              data-width="100%"
              data-href={url}
            />
          </div>
        </div>
      </div>
    </section>
  );

  const disqusShortname = 'livesession-io'; // found in your Disqus.com dashboard
  const disqusConfig = {
    url: `http://livesession.io${url}`, // this.props.pageUrl
    identifier: url, // this.props.uniqueId
    title,
  };

  const { authorName, authorDesc, avatar, bio } = author;

  const formattedDate = format(new Date(date), 'do MMMM yyyy');

  return (
    <Layout
      metaTitle={`${metaTitle || title} | LiveSession ${tutorials ? 'Tutorials' : 'Blog'}`}
      titleOverride
      metaDescription={description}
      canonical={url}
      datePublished={date}
      author={authorName}
      image={img}
    >
      <section style={{ paddingTop: '1rem' }}>
        <Styled.ContentContainer className="container">
          <div className="row justify-content-center">
            <Styled.Header className="col-12 col-md-10 col-lg-10">
              <Styled.ImgCoverContainer className="justify-content-center mb-4">
                {typeof img === 'object' ? (
                  <Img
                    alt={title}
                    fluid={img}
                    className="img-fluid"
                    style={{ width: '100%', top: 0 }}
                  />
                ) : img === undefined ? null : (
                  <img
                    alt={title}
                    src={img}
                    className="img-fluid"
                    style={{ width: '100%', top: 0 }}
                  />
                )}
              </Styled.ImgCoverContainer>
            </Styled.Header>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <Styled.Title>{title}</Styled.Title>
              <div className="media blog-post-author" style={{ marginBottom: '3rem' }}>
                <img alt={authorName} src={avatar} className="avatar mr-3" />
                <div className="media-body">
                  <span className="h6">{authorName}</span>
                  <span className="text-small" style={{ opacity: '.75', fontSize: '.75rem' }}>
                    <span>{formattedDate}</span>
                    {timeToRead && <Styled.TimeToRead>{timeToRead} min</Styled.TimeToRead>}
                  </span>
                </div>
              </div>
              <Content {...props} />
            </div>
          </div>
        </Styled.ContentContainer>
      </section>
      <NewsletterBox blogPost />
      <Styled.ArticleFooter>
        <div className="container">
          <div className="row justify-content-center mb-2">
            <div className="col-auto text-center">
              <span style={{ marginBottom: 10, display: 'block' }}>Share</span>
              <ul className="list-inline">
                <li className="list-inline-item">
                  <TwitterShareButton url={url}>
                    <img alt="Share on Twitter" src={imgTwitter} />
                  </TwitterShareButton>
                </li>
                <li className="list-inline-item">
                  <FacebookShareButton url={url}>
                    <img alt="Share on Facebook" src={imgFB} />
                  </FacebookShareButton>
                </li>
                <li className="list-inline-item">
                  <LinkedinShareButton url={url}>
                    <img alt="Share on LinkedIn" src={imgLI} />
                  </LinkedinShareButton>
                </li>
              </ul>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-6 col-lg-6 text-center">
              <img
                alt={authorName}
                src={avatar}
                className="avatar avatar-lg mb-3 profile-picture"
              />
              <h5>{authorName}</h5>
              {!bio && <span>{authorDesc}</span>}
              {bio && <p className="bio">{bio}</p>}
            </div>
          </div>
        </div>
      </Styled.ArticleFooter>
      <section
        style={{
          borderTop: '1px solid #eaebec',
          paddingTop: '3rem',
          paddingBottom: '3rem',
          maxWidth: '800px',
          margin: '0 auto',
        }}
      >
        <div className="container">
          <div className="mt-5">
            <Disqus.DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
          </div>
        </div>
      </section>
      {renderFacebookComments()}
      {renderRelatedList()}
    </Layout>
  );
};
